import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import { type ISwitchActionProps, SwitchAction } from 'shared/ui/SwitchAction'
import { type IKeyword } from 'entities/Keywords'
import { keywordActionsStore } from 'pages/keywords/pages/all/ui/KeywordsTable/getKeywordActions'

type Props = {
  item: IKeyword
  size?: ISwitchActionProps['size']
  className?: string
}

export const KeywordActiveToggle = observer(({ item, size = 'small', className }: Props) => (
  <div className={className}>
    <Tooltip label={item.isInvalid && 'Suspicious content detected'} placement={'top'}>
      <SwitchAction
        size={size}
        active={item.status === 'active'}
        disabled={item.isInvalid}
        onTrigger={async () => {
          await keywordActionsStore.updateStatus(item)
        }}
        ariaLabel={`KeywordActiveToggle-${item.id}`}
      />
    </Tooltip>
  </div>
))
